import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Logger from '../functions/logging';
import '../static/mpaa.css';

import FadeIn from '../components/global/FadeIn';
import Feedback from '../components/global/Feedback';
import PageLoader from '../components/global/PageLoader';

import tvgRating from '../assets/mpaa-ratings/tv-g.gif';
import tvpgRating from '../assets/mpaa-ratings/tv-pg.gif';
import tv14Rating from '../assets/mpaa-ratings/tv-14.gif';
import tvmaRating from '../assets/mpaa-ratings/tv-ma.gif';
import gRating from '../assets/mpaa-ratings/g.gif';
import pgRating from '../assets/mpaa-ratings/pg.gif';
import pg13Rating from '../assets/mpaa-ratings/pg-13.gif';
import rRating from '../assets/mpaa-ratings/r.gif';

import * as auth from '../functions/auth';
import * as TargetProcess from '../functions/targetProcess';
import { getUser } from '../api/user';
import { groupJoinSubscription, groupSubscribe } from '../api/group';
import { setTargetParams, setCurrentUser } from '../redux/actions/index';

import localeMessages from '../locales/register';
import { getLanguageWithoutRegionCode, getLocale } from '../functions/locale';
import { enableFullscreen } from '../functions/fullscreen';

class MPAAWarning extends Component {
	constructor(props) {
		super(props);

		this.state = {
			countDown: 5,
			beginCountDown: false
		};

		this.gotoStudy = this.gotoStudy.bind(this);
	}

	componentDidMount() {
		if(!this.props.fetchedGroup) {
			this.props.history.push('/');
		}

		// get the user object if user_token exists
		let user_token = auth.getToken();
		if (user_token && (!this.props.targetParams || (!this.props.targetParams.partner && !this.props.targetParams.dl))) {
			this.loadUser(user_token);
		}

		setTimeout(() => {
			this.setState({beginCountDown: true, countDownStarted: true});
		}, 1100);
	}

	/*
		componentDidUpdate() {
			if (this.state.countDown > 0 && this.state.beginCountDown && this.props.fetchedEpisode) {
				setTimeout(() => {
					this.setState({countDown: this.state.countDown - 1});
				}, 1100);
			
			} else if (this.state.countDown <= 0) {
				this.gotoStudy();
			} 
		}
	*/

	async gotoStudy() {
		//The Web API requestFullscreen() just works when executed by a user interaction. Click or touch.
		await enableFullscreen();
		this.props.history.push('/study');
	} 
	
	async loadUser(user_token, callback) {
		try {
			const result = await getUser(user_token);
			if (result) {
				Logger.log(this.constructor.name, "loadUser() User Success", result);
				this.props.setCurrentUser(result);
				if (callback) callback();
			}
			else {
				Logger.log(this.constructor.name, "loadUser() User Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				this.setState({ errors });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "loadUser() User Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors });
		}
	}

	async setTerminatedUserSubscription(screen_code) {
		let user_token = auth.getToken();
		let user_id = this.props.currentUser.user_id;
		let video_id = this.props.fetchedGroup.video_id;
		let group_id = this.props.fetchedGroup._id;
		let panelSegmentIndex = this.props.targetParams.ps || this.props.targetParams.ps === 0 ? this.props.targetParams.ps.toString() : null;
		let subscribeFn = this.props.targetParams && (this.props.targetParams.partner || this.props.targetParams.dl) ? groupJoinSubscription : groupSubscribe;
		const isTester = TargetProcess.isTester(this.props.targetParams);
		const userLanguageCode = getLocale() || (this.props.targetParams && this.props.targetParams.lang) || getLanguageWithoutRegionCode();

		Logger.log(this.constructor.name, "setTerminatedUserSubscription() suscribe, tester", (this.props.targetParams && (this.props.targetParams.partner || this.props.targetParams.dl)), isTester, this.props.targetParams);
		try {
			const result = await subscribeFn(user_token, user_id, video_id, group_id, panelSegmentIndex, userLanguageCode, 1, screen_code, isTester, true);

			if (result) {
				Logger.log(this.constructor.name, "setTerminatedUserSubscription() Group: ", result);
				this.setState({ feedbackType: "ineligible" });
			}
			else {
				Logger.log(this.constructor.name, "setTerminatedUserSubscription() Group Subscription Failed: No result");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_terminating_user);
				this.setState({ errors: errors });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			let reason = error.reason ? error.reason : error.toString();
			if (error.error === 403 || error.error === "accounts") {
				reason = "Something bad";
			}
			Logger.log(this.constructor.name, "setTerminatedUserSubscription() Group Subscription Failed", reason, error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_terminating_user);
			this.setState({ errors: errors });
		}
	}

	validateUserFeedback(currentUser, currentStudy) {
		if (currentUser && currentUser.subscriptions && currentUser.subscriptions.list && currentUser.subscriptions.list.length && currentStudy) {
			for (let i = 0; i < currentUser.subscriptions.list.length; i++) {
				let subscribedStudy = currentUser.subscriptions.list[i];
				if (subscribedStudy.screened && subscribedStudy.group_id === currentStudy._id) {
					return "ineligible";
				}
			}
		}
		
		if (currentUser && currentUser.subscriptions && currentUser.subscriptions.group && currentUser.subscriptions.group.length && currentStudy) {
			for (let i = 0; i < currentUser.subscriptions.group.length; i++) {
				let subscribedStudy = currentUser.subscriptions.group[i];
				if (subscribedStudy.screened && subscribedStudy.group_id === currentStudy._id) {
					return "ineligible";
				}
			}
		}
		return null;
	}

	terminateUser(screen_code) {
		this.setState({ ready: false });
		if (this.props.currentUser) {
			this.setTerminatedUserSubscription(screen_code);
		}
	}

	renderMPAARating(episode) {
		if (episode && episode.mpaa) {
			switch(episode.mpaa.label) {
				case "tv-g":
					return <img className="pull-left" src={tvgRating} alt="TV G"/>;
				case "tv-pg":
					return <img className="pull-left" src={tvpgRating} alt="TV PG"/>;
				case "tv-14":
					return <img className="pull-left" src={tv14Rating} alt="TV 14"/>;
				case "tv-ma":
					return <img className="pull-left" src={tvmaRating} alt="TV MA"/>;	
				case "g":
					return <img className="pull-left" src={gRating} alt="G" />;
				case "pg":
					return <img className="pull-left" src={pgRating} alt="PG" />;
				case "pg-13":
					return <img className="pull-left" src={pg13Rating} alt="PG-13" />;
				case "r":
					return <img className="pull-left" src={rRating} alt="R" />;	
			} 
		}
		return <img className="pull-left" src={tvgRating} alt="TV G"/>;	 
	}

	renderMPAAWarnings(episode) {
		let warnings = {
			d: "Suggestive Dialogue",
			fv: "Fantasy Violence",
			s: "Sexual Content",
			v: "Violence",
			l: "Coarse Language"
		};
		let mpaaWarnings = [];
		if (episode && episode.mpaa && episode.mpaa.warnings && episode.mpaa.warnings.length) {
			episode.mpaa.warnings.forEach((warningType) => {
				mpaaWarnings.push(
					<li key={warnings[warningType]} className="mpaa-warning"><b>{warningType}</b> - {warnings[warningType]}</li>
				);
			});
		}
		return mpaaWarnings.length ? mpaaWarnings : "";
	}

	render() {
		let mpaaRating = this.renderMPAARating(this.props.fetchedEpisode);
		let mpaaWarnings = this.renderMPAAWarnings(this.props.fetchedEpisode);
		let noMPAARatingsClass = mpaaWarnings.length === 0 ? " no-mpaa-warnings" : "";
		let feedbackType = this.validateUserFeedback(this.props.currentUser, this.props.fetchedGroup) || this.state.feedbackType;

		// return feedback component if redirects are needed
		if (feedbackType) {
			return <Feedback {...this.props} feedbackType={feedbackType} />;
		}

		return (
			<FadeIn>
				<div className="pilotly-mpaa">
					<div className="row ready-to-begin">
						{!this.props.fetchedEpisode ? 
							<PageLoader loading={(!this.state.fetchedEpisode) || this.state.loading} small={true} />
							:
							<div className="mpaa-container">
								<div className={"mpaa-wrapper" + noMPAARatingsClass}>
									<div className="mpaa-rating col s6">
										<p className="mpaa-message mb-20">
											<FormattedMessage
												id="mpaa.message"
												defaultMessage={"The following screening is rated:"}
											/>
										</p>
										{ mpaaRating }
									</div>

									<div className="warning-list col s6">
										<ul>
											{ mpaaWarnings }
										</ul>
									</div>
									
									<div className="continue-wrapper col s12 mt-30">
										<button className="waves-effect waves-light btn register-field-submit begin-registration text-capitalize transparent pilotly-home-footer-sign-out-button-no mr-10 text-capitalize"
											onClick={() => this.terminateUser('mpaa')}>
											<FormattedMessage
												id="mpaa.button.exit"
												defaultMessage={"Exit the Study"}
											/>
										</button>

										<button className="btn waves-effect waves-light text-capitalize"
											onClick={this.gotoStudy}>
											{/* {this.state.countDown} -  */}
											<FormattedMessage
												id="mpaa.button.continue"
												defaultMessage={"Continue"}
											/>											
										</button>

									</div>
								</div>
							</div>
						}
					</div>
				</div>
			</FadeIn>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		fetchedDistributionList: state.targetProcess.fetchedDistributionList,
		fetchedEpisode: state.targetProcess.fetchedEpisode,
		fetchedGroup: state.targetProcess.fetchedGroup,
		targetParams: state.targetProcess.targetParams
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setTargetParams,
		setCurrentUser
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MPAAWarning);



// WEBPACK FOOTER //
// ./src/pages/MPAA.js